import React, { useState } from 'react';
import { IRouteDetailsKeyValueProps } from '../../../../../sp-types/routeDetailsType';

export const InputRouteDetailsKeyValue: React.FC<IRouteDetailsKeyValueProps> = ({ data, update = () => {} }) => {
  const [rows, setRows] = useState(data);

  const handleRowChange = (index: number, key: string, value: string) => {
    const updatedRows = rows.map((row, idx) => (idx === index ? { ...row, [key]: value } : row));
    setRows(updatedRows);
    update({ data: updatedRows });
  };

  const handleAddRow = () => {
    const newRow = { label: '', value: '' };
    const updatedRows = [...rows, newRow];
    setRows(updatedRows);
    update({ data: updatedRows });
  };

  const handleDeleteLastRow = () => {
    const updatedRows = rows.slice(0, -1);
    setRows(updatedRows);
    update({ data: updatedRows });
  };

  return (
    <div className="flex flex-row gap-2">
      <div className="grid grid-cols-2 border text-sm border-gray-300 ">
        {rows.map((row, index) => (
          <React.Fragment key={index}>
            <input
              type="text"
              className="border border-gray-300 p-2 bg-gray-50"
              value={row.label}
              onChange={(e) => handleRowChange(index, 'label', e.target.value)}
              placeholder="Label"
            />
            <input
              type="text"
              className="border border-gray-300 p-2"
              value={row.value}
              onChange={(e) => handleRowChange(index, 'value', e.target.value)}
              placeholder="Value"
            />
          </React.Fragment>
        ))}
      </div>
      <div className="flex flex-col gap-1 bg-gray-50 rounded-md p-2  ">
        <button className="p-1 border rounded text-sm bg-white" onClick={handleDeleteLastRow}>
          Delete last row
        </button>
        <button className="p-1 border rounded text-sm bg-white" onClick={handleAddRow}>
          Add Row
        </button>
      </div>
    </div>
  );
};
